var jQuery = $;
import bridget from '../../node_modules/jquery-bridget/jquery-bridget.js';
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

Swiper.use([Pagination, EffectFade]);

const app = {
    /** Initialize */
    init() {
        // Make Masonry a jQuery plugin
        var $ = require('jquery');
        var jQueryBridget = require('jquery-bridget');
        // var Masonry = require('masonry-layout');
        // jQueryBridget('masonry', Masonry, $);

        // Toggle sub navigation items
        this.toggleSubnavigation();

        // Smooth scroll to Anchor
        this.smoothAnchor();

        // FAQ Toggle
        this.toggleFooterItems();

        // Initialize Sliders
        this.initSliders();

        // this.adjustColumnClasses();

        // Open/Close Popup
        this.OpenClosePopup();

        // Masonry grid
        // this.masonry();

        // PageHeader Video
        this.setCorrectSrc();

        // Check offerte popup errors
        this.checkOffertePopupErrors();
        this.checkContactFormErrors();

        // Init call request
        this.initCallRequest();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    lazyLoadVimeo() {
        var iframe = document.querySelector('iframe.lazyload');

        function handleLazyLoad() {
            if (iframe) {
                const storeSRC = iframe.dataset.src;
        
                delete iframe.dataset.src;
                iframe.src = storeSRC;
            } 
        }
    
        handleLazyLoad();
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $("body").toggleClass('is-locked');
    },

    // adjustColumnClasses() {
    //     $('.image-content-columns').each(function() {
    //         var columnCount = $(this).find('.column').length;
    //         if (columnCount >= 2) {
    //             if (columnCount % 2 === 0) {
    //                 $(this).addClass('two-cols');
    //             } else if (columnCount >= 3) {
    //                 $(this).addClass('three-cols');
    //             }
    //         }
    //     });
    // },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header, main').toggleClass('scrolled', $(window).scrollTop() > 0);
    },

    /** Toggle sub navigation items */
    toggleSubnavigation() {
        if ($(window).width() < 1025) {
            $("nav.navigation ul li.has-children a.navlink").click(function (e) {
                e.preventDefault();
                $(this).parent().toggleClass("is-opened").find("ul").slideToggle("slow");
                $(this).find("a.navlink").toggleClass("active");
            });
        }
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        $(document).on('click', 'main a[href^="#"]', function (e) {
            let id = $(this).attr('href');
            let $id = $(id);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            let pos = $id.offset().top - 60;
            $('body, html').animate({ scrollTop: pos });
        });
    },

    /** Open/Close Popup */
    OpenClosePopup() {

        $('a[href^="#offerte"]').click(function (e) {
            e.preventDefault();
            $.fancybox.open({
                src: '.popup',
                type: 'inline',
                touch: false,
                smallBtn: false,
                clickSlide: false,
                buttons: [],
                openEffect: 'none',
                closeEffect: 'none',
            });
        });

        $('.close-popup').click(function () {
            $.fancybox.close();
        });
    },

    /** Initialize Sliders */
    initSliders() {

        if ($(window).width() <= 768) {

            // Columns mobile slider
            if ($('.columns').length) {
                $('.columns').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 2500,
                    arrows: false,
                    dots: false,
                    fade: false,
                    centerMode: true,
                    centerPadding: '40px',
                });
            }
        }

        // Content slider
        if ($('.slider').length) {
            new Swiper('.slider', {
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true,
                },
                fadeEffect: {
                    crossFade: true
                },
                effect: 'fade',
            });
        }

        // Review sliders
        if ($('.review-content .review-slider').length) {
            $('.review-content .review-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 2500,
                asNavFor: '.review-content .synced-slider'
            });

            $('.review-content .review-slider-nav').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.review-content .synced-slider',
                arrows: false,
                dots: false,
                centerMode: true,
                focusOnSelect: true
            });

            $('.review-content .review-slider-alt').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.review-content .synced-slider',
                arrows: true,
                dots: false,
                fade: true,
                nextArrow: '.review-content .arrows .arrow.next',
                prevArrow: '.review-content .arrows .arrow.prev',
            });
        }
    },

    /** FAQ Toggle */
    toggleFooterItems() {

        if ($(window).width() <= 768) {

            $('footer .item-title').click(function (e) {
                e.preventDefault();
                var $this = $(this);
                if ($this.hasClass('is-opened')) {
                    $this.removeClass('is-opened');
                    $this.next().removeClass('is-opened');
                    $this.next().slideUp(350);
                } else {
                    $this.toggleClass('is-opened');
                    $this.next().toggleClass('is-opened');
                    $this.next().slideToggle(350);
                }
            });
        }
    },

    /** Masonry Grid */
    // masonry() {
    //     setTimeout(function () {
    //         var $grid = $('.projects-grid.is-masonry').masonry({
    //             columnWidth: '.masonry-sizer',
    //             itemSelector: 'a.project',
    //             percentPosition: true
    //         });
    //     }, 5000);

    // },

    /** PageHeader Video */
    setCorrectSrc() {
        var self = this;
        $(document).ready(function () {
            var variations = {
                'beneath': 'https://player.vimeo.com/video/898129042?badge=0&autopause=0&autoplay=1&muted=1&playsinline=1&player_id=0&app_id=58479&background=1',
                'above': 'https://player.vimeo.com/video/899438043?badge=0&autopause=0&autoplay=1&muted=1&playsinline=1&player_id=0&app_id=58479&background=1',
            };

            function setVideoSource() {
                var videoWrapper = $('.pageheader .video-wrapper');
                if (videoWrapper.length && $(".pagehero-iframe")[0]) {
                    let aspectRatio = videoWrapper.width() / videoWrapper.height();
                    let diffTo16by9 = Math.abs(aspectRatio - (16 / 9));
                    let diffTo1by1 = Math.abs(aspectRatio - 1);

                    let iframe = document.getElementsByClassName('pagehero-iframe')[0];
                    if (diffTo16by9 < diffTo1by1) {
                        iframe.setAttribute('data-src', variations['above']);
                    } else {
                        iframe.setAttribute('data-src', variations['beneath']);
                    }
                }
            }

            // Set the video source initially
            setVideoSource();

            // Add a resize event listener to the window
            $(window).resize(function () {
                setVideoSource(); // Set the video source again when the window is resized
            });

            self.lazyLoadVimeo();
        });
    },

    checkOffertePopupErrors() {
        $('.offerte-popup-form input[type="submit"]').click(function () {
            setTimeout(function () {
                $('input[aria-invalid="true"]').first().focus();
            }, 5000);
        });
    },

    checkContactFormErrors() {
        $('.contact-form-wrapper input[type="submit"]').click(function () {
            setTimeout(function () {
                $('input[aria-invalid="true"]').first().focus();
            }, 5000);
        });
    },

    initCallRequest() {
        setTimeout(function () {
            if (!document.cookie.match(/^(.*;)?\s*call_request\s*=\s*[^;]+(.*)?$/)) {
                if ($('.call-request').length) {
                    $('.call-request').fadeIn(500);
                }
            }
        }, 45000);

        $('.call-request .close-button').on('click', function () {
            createCookie('call_request', 'closed', 1);
            $('.call-request').fadeOut(500);
        });

        $('.call-request .link').on('click', function () {
            createCookie('call_request', 'closed', 1);
            $('.call-request').fadeOut(500);
        });

        function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }
};
$(document).ready($.proxy(app.init, app));

function deferImgs() {
    Array
    .from(document.querySelectorAll("img[data-src-defer]"))
    .forEach((element) => {
        element.setAttribute("src", element.dataset.srcDefer);
        });
}

window.addEventListener("load", deferImgs());